import React, { useRef, useState } from 'react';
import contriesList from 'iso-3166-1-alpha-2';
import { useDispatch } from 'react-redux';
import { RegexFields } from './../../../../../constants/utils/regexFields';
import {DateWithModal} from '../../../../../_common/dateWithModal';
import {updateDeathDeclaration} from '../../../../../actions/facilita-api';
import * as loadings from '../../../../../constants/loadings/facilita/deathDeclaration';
import $ from 'jquery';
import * as R from 'ramda';

export const ModalCivil = ({deathDeclaration, userId, isLoading}) => {
	const dispatch = useDispatch();
	var countries = require("i18n-iso-countries");
    countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
	const civilForm = useRef(null);

	const [personalData, setPersonalData] = useState({
		firstName: deathDeclaration.firstName,
		lastName: deathDeclaration.lastName,
		birthDate: deathDeclaration.birthDate,
		country: deathDeclaration.country,
		phone: deathDeclaration.userResidenceAddress.phoneNumber,
		mobile: deathDeclaration.phoneNumber,
		isInvalid: deathDeclaration.isInvalid,
	});

	return (
		<div className="modal fade px-0" id="civilModal" aria-labelledby="civilModalLabel" aria-hidden="true">
			<div className="modal-dialog px-2 container-screen">
				<div className="modal-content">
					<div className="modal-header" data-dismiss="modal" aria-label="Close">
						<div className="alert bg-common rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Information deceased</h1>
							<div className="h4 text-primary text-uppercase mb-0 font-weight-bolder ls-n1 lh-1" id="civilModalLabel">modifier les champs</div>
						</div>
					</div>
					<div className="modal-body scroll-default py-0">
						<p className="o-60 pt-3">Modifier les informations qui ne sont pas à jour.</p>
						<form className="flex-column pt-3" ref={civilForm}>
							<div className="form-row">
								<div className="form-group col-12 col-sm">
									<label className="h6 font-weight-bolder my-auto" htmlFor="Prenom">Prénom *</label>
									<input required type="text" className="form-control" id="Prenom" defaultValue={personalData.firstName} onChange={(e) => {
										e.preventDefault();
										setPersonalData({ ...personalData, firstName: e.target.value });
									}} pattern={RegexFields.nameWithoutNumbers} />
								</div>
								<div className="form-group col-12 col-sm">
									<label className="h6 font-weight-bolder my-auto" htmlFor="Nom">Nom *</label>
									<input required type="text" className="form-control" id="Nom" defaultValue={personalData.lastName} onChange={(e) => {
										e.preventDefault();
										setPersonalData({ ...personalData, lastName: e.target.value });
									}} pattern={RegexFields.nameWithoutNumbers} />
								</div>
								<div className="col-12 d-md-none"></div>
								<div className="form-group col-12 col-sm">
									<label className="h6 font-weight-bolder my-auto" htmlFor="naissance">Date de naissance *</label>
									<DateWithModal isRequired={true} selectedDate={personalData.birthDate} setSelectedDate={((d) => setPersonalData({...personalData, birthDate: d}))} />
								</div>
								<div className="col-12"></div>
								<div className="form-group col-12 col-sm">
									<label className="h6 font-weight-bolder my-auto" htmlFor="naturalite">Pays *</label>
									<select className="custom-select" id="naturalite" tabIndex={-98} value={personalData.country} onChange={(event) => {
										setPersonalData({ ...personalData, country: event.target.value });
									}}>
										{
											Object.keys(contriesList.getData()).map((country, index) => {
												return (
													<option key={index} value={country}>{countries.getName(country, "fr", {select: "official"})}</option>
												);
											})
										}
									</select>
								</div>
							</div>
							<div className="form-row">
								<div className="form-group col-12 col-sm">
									<label className="h6 font-weight-bolder my-auto" htmlFor="Téléphone">Téléphone fixe</label>
									<input type="tel" className="form-control" id="Téléphone" placeholder="00 00 00 00 00" defaultValue={personalData.phone} onChange={(event) => {
										setPersonalData({ ...personalData, phone: event.target.value })
									}} pattern={RegexFields.frenchPhoneNumber} />
								</div>
								{
									R.isNil(personalData.mobile) || personalData.mobile.startsWith("+00") ? 
										""
									:
										<div className="form-group col-12 col-sm">
											<label className="h6 font-weight-bolder my-auto" htmlFor="mobile">Téléphone mobile</label>
											<input type="tel" className="form-control" id="mobile" placeholder="00 00 00 00 00" defaultValue={personalData.mobile} required onChange={(event) => {
												setPersonalData({ ...personalData, mobile: event.target.value })
											}} pattern={RegexFields.frenchPhoneNumber} />
										</div>
								}
							</div>
							<div className="form-row bg-common px-4 py-2 mx-n4">
								<div className="form-group col-12 col-sm my-3">
									<label className="h5 font-weight-bolder my-auto" htmlFor="isHandicaped">Le défunt était-il invalide à la date du décès?</label>
									<select className="custom-select" id="isHandicaped" tabIndex={-98} defaultValue={personalData.isInvalid} onChange={(event) => {
										setPersonalData({ ...personalData, isInvalid: event.target.value });
									}}>
										<option value="false">Non</option>
										<option value="true">Oui</option>
									</select>
								</div>
							</div>
						</form>
					</div>
					<div className="modal-footer pt-3">
						<button type="button" className="btn btn-light mr-2" data-dismiss="modal">Fermer</button>
						{
							isLoading.includes(loadings.UPDATING_DECLARATION) ? 
								<button type="button" className="btn btn-info loading-btn show"><div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Sauvegarder</button>

							:
								<button type="button" className="btn btn-info" onClick={(e) => {
									e.preventDefault();
									civilForm.current.classList.add('was-validated');
									if (civilForm.current.checkValidity()){
										dispatch(updateDeathDeclaration(userId, {
											...deathDeclaration,
											firstName: personalData.firstName,
											lastName: personalData.lastName,
											birthDate: personalData.birthDate,
											country: personalData.country,
											phoneNumber: personalData.mobile,
											isInvalid: personalData.isInvalid,
											userResidenceAddress: {...deathDeclaration.userResidenceAddress, phoneNumber:personalData.phone}
										})).then(() => $('.modal').modal("hide"));
									}
								}}>Sauvegarder</button>
						}
						
					</div>
				</div>
			</div>
		</div>
	)
}